const enviarMailInitialState = {
    enviarMail: {
        loading: false,
        error: null,
        data: null
    },
};

export default enviarMailInitialState;